import { render, staticRenderFns } from "./cAdminAtlasUsage.vue?vue&type=template&id=3acf84e4&scoped=true"
import script from "./cAdminAtlasUsage.vue?vue&type=script&lang=js"
export * from "./cAdminAtlasUsage.vue?vue&type=script&lang=js"
import style0 from "./cAdminAtlasUsage.vue?vue&type=style&index=0&id=3acf84e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acf84e4",
  null
  
)

export default component.exports